<template>
    <div class="account-login-page">
        <Header ref="header" activeIndex="/support" />
        
        <!-- Hero Section -->
        <div class="page-hero">
            <div class="hero-content">
                <div class="navigation-wrapper">
                    <div class="back-button" @click="$router.push('/faq')">
                        <i class="el-icon-arrow-left"></i>
                        Back to FAQ
                    </div>
                </div>
            </div>
        </div>

        <!-- Content Section -->
        <div class="page-content">
            <div class="content-header">
                <div class="icon-title">
                    <i class="el-icon-user icon"></i>
                    <h1>Account & Login</h1>
                </div>
            </div>

            <div class="faq-grid">
                <div v-for="(item, index) in faqData.accountLogin" 
                     :key="index" 
                     class="faq-item"
                     :class="{ 'is-active': activeIndex === index }">
                    <div class="question" @click="toggleAnswer(index)">
                        <span class="question-text">{{ item.question }}</span>
                        <i class="el-icon-arrow-down toggle-icon"></i>
                    </div>
                    <div class="answer" v-show="activeIndex === index">
                        <div class="answer-content" v-html="renderAnswer(item)"></div>
                    </div>
                </div>
            </div>
        </div>
        <FeedBack />
    </div>
</template>

<script>
import Header from '@/components/header.vue'
import FeedBack from '@/components/feedback.vue'
import { faqData } from './faqData.js'

export default {
    components: { Header, FeedBack },
    data() {
        return {
            faqData,
            activeIndex: null
        }
    },
    methods: {
        toggleAnswer(index) {
            this.activeIndex = this.activeIndex === index ? null : index
        },
        renderAnswer(item) {
            if (typeof item.answer === 'function') {
                return item.answer(item.images);
            }
            return item.answer;
        }
    }
}
</script>

<style lang="scss" scoped>
.account-login-page {
    min-height: 100vh;
    padding-bottom: 60px;
    position: relative;
    background: #fff;
}

.page-hero {
    background: linear-gradient(135deg, #0D7BC1 0%, #0D7BC1 100%);
    padding: 30px 40px;
    color: white;
    border-bottom: 1px solid rgba(0,0,0,0.05);
    position: relative;
    z-index: 10;
}

.hero-content {
    max-width: 1200px;
    margin: 0 auto;
}

.navigation-wrapper {
    text-align: left;
}

.back-button {
    display: inline-flex;
    align-items: center;
    color: rgba(255, 255, 255, 0.9);
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 15px;
    padding: 8px 16px;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.1);

    i {
        margin-right: 8px;
        font-size: 14px;
    }

    &:hover {
        color: white;
        background: rgba(255, 255, 255, 0.15);
        transform: translateX(-4px);
    }
}

.page-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px;
}

.content-header {
    margin-bottom: 40px;

    .icon-title {
        display: flex;
        align-items: center;
        gap: 15px;

        .icon {
            font-size: 38px;
            color: #0D7BC1;
        }

        h1 {
            font-size: 34px;
            font-weight: 600;
            color: #0D7BC1;
            margin: 0;
        }
    }
}

.faq-grid {
    display: grid;
    gap: 20px;
}

.faq-item {
    background: white;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    border: 1px solid #eee;
    overflow: hidden;

    &.is-active {
        box-shadow: 0 2px 12px rgba(13, 123, 193, 0.1);
        
        .question {
            color: #0D7BC1;
        }

        .toggle-icon {
            color: #0D7BC1;
        }
    }
}

.question {
    padding: 20px 24px;
    display: flex;
    justify-content: space-between; /* 左右对齐 */
    align-items: center; /* 垂直居中 */
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        background: rgba(13, 123, 193, 0.05);
    }

    .question-text {
        font-size: 20px;
        color: #2C3E50;
        line-height: 28px;
        font-weight: 500;
        text-align: left; /* 左对齐文本 */
    }

    .toggle-icon {
        font-size: 16px;
        color: #666;
        transition: all 0.3s ease;
        margin-left: auto; /* 将图标推到最右边 */
    }
}

.answer {
    border-top: 1px solid #eee;
    
    .answer-content {
        padding: 24px;
        color: #3C4858;
        line-height: 1.8;
        font-size: 16px;
        background: #F8FAFC;
        text-align: left; /* 左对齐文本 */

        :deep(img) {
            width: 400px;
            height: auto;
            margin: 15px auto;
            display: block;
            border: 1px solid #E2E8F0;
            border-radius: 6px;
            box-shadow: 0 2px 8px rgba(13, 123, 193, 0.08);
            object-fit: contain;
        }

        @media (max-width: 768px) {
            :deep(img) {
                width: 300px;
            }
        }

        @media (max-width: 480px) {
            :deep(img) {
                width: 250px;
            }
        }
    }
}

@media (max-width: 768px) {
    .page-hero {
        padding: 20px;
    }

    .page-content {
        padding: 30px 20px;
    }

    .content-header {
        .icon-title {
            h1 {
                font-size: 28px;
            }
        }
    }

    .question {
        .question-text {
            font-size: 18px;
        }
    }
}
</style> 